import {SensorWCActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const SensorWCRequestInit = () => {
    return {
        type:SensorWCActionType.SensorWC_INIT
    }
}

export const SensorWCSuccess = (
    objeckt: any
) => {
    return {
        type: SensorWCActionType.SensorWC_INIT,
        objeckt: objeckt
    }
}

export const getSensorWC = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            SensorWCSuccess(
                objeckt
            )
        )
    }
}
